import React, { useContext, useEffect } from 'react';
import { ChartUp } from 'esa-ui-library/lib/assets/icons/ChartUp';
import { Money } from 'esa-ui-library/lib/assets/icons/Money';
import { UserCircle } from 'esa-ui-library/lib/assets/icons/UserCircle';
import { Header, Page, PageAuth, PageContainer } from '../../components';
import { PERMISSIONS } from '../../constants';
import styles from '../Dashboard/Dashboard.module.scss';
import { AuthContext } from '../../../logic';
import { toAmountString, useStore } from '../../../common';
import { Chart, registerables } from 'chart.js';
import { DashboardCard } from './DasboardCard/DashboardCard';
import DoughnutChart from '../../components/Charts/DoughnutChart/DoughnutChart';
import BarChart from '../../components/Charts/BarChart/BarChart';
import { DashboardSkeleton } from './DashboardSkeleton/DashboardSkeleton';
import { RangePicker } from '../../components/RangePicker/RangePicker';
import { find, isEmpty } from 'lodash';

Chart.register(...registerables);

const Dashboard = (): JSX.Element => {
	const { token } = useContext(AuthContext);
	const [state, dispatch] = useStore();
	const { summary, devices, categories, providers, statistics, dashboardLoading, filters } = state;
	const startDate = find(filters, ['name', 'start_date'])?.value;
	const endDate = find(filters, ['name', 'end_date'])?.value;

	useEffect(() => {
		dispatch('LOADING', true);
		dispatch('DASHBOARD_INIT', { token, filters });
	}, []);

	const getSkinName = (val: string) => {
		const values = val?.split('-');
		return values[1] ? values[1].trim() : val;
	};

	return (
		<>
			<Header dataId='header' />
			<PageAuth permission={PERMISSIONS.canViewOwnDetails}>
				<PageContainer>
					<Page>
						{!process.env.REACT_APP_SITE_TITLE?.includes('Italy') ? (
							<section className={styles.PageContent}>
								<RangePicker startDate={startDate} endDate={endDate} />
								{dashboardLoading || isEmpty(summary) ? (
									<DashboardSkeleton />
								) : (
									<div className={styles.CardsSection}>
										<DashboardCard
											icon={<Money />}
											title='Total Turnover'
											value={toAmountString(statistics.bet, 'EUR')}
											backgroundColor='#8BC544'
											color='#fff'
										/>
										<DashboardCard icon={<Money />} title='Total GGR' value={toAmountString(statistics.ggr, 'EUR')} />
										<DashboardCard icon={<ChartUp />} title='Growth' value={`${statistics.growth_rate || 0}%`} />
										<DashboardCard icon={<UserCircle />} title='Number of Active Players' value={statistics.uap} />
										{!isEmpty(devices) && <DoughnutChart data={devices} title='Device Breakdown' />}
										{!isEmpty(summary) && (
											<section>
												<BarChart title='Top Games by GGR' data={summary.ggr} />
												<BarChart title='Top Games by Turnover' data={summary.bet} />
											</section>
										)}
										{!isEmpty(categories) && <DoughnutChart data={categories} title='Game Category Split' />}
										<section>
											{!isEmpty(providers) && (
												<BarChart title='Top 5 Operators by Turnover' data={providers} labelFormater={getSkinName} />
											)}
										</section>
									</div>
								)}
								<small style={{ float: 'right', marginTop: '10px', opacity: 0.4 }}>
									*The dashboard includes only data from closed sessions for ESA games.
								</small>
							</section>
						) : (
							<div />
						)}
					</Page>
				</PageContainer>
			</PageAuth>
		</>
	);
};

export { Dashboard };
